export default "__VITE_ASSET__CR_tPNaq__"